<template>
  <div class="poste-livraison-list">
    <card class="card" title="Poste(s) de livraison">
      <!-- Tableau affichage -->
      <b-table-simple
        v-if="isPostesLivraison"
        caption-top
        hover
        responsive
        small
      >
        <b-thead variant="dark">
          <b-tr>
            <b-th>Numéro</b-th>
            <b-th></b-th>
            <b-th></b-th>
            <b-th class="table-action-column">Action(s)</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="poste in postesLivraison"
            :key="poste.id"
            :class="{
              'selected-line': isSelectedLine(poste.id)
            }"
            @mouseout="onLineOut()"
            @mouseover="onLineHover(poste.id)"
          >
            <b-td>{{ poste.id }}</b-td>
            <b-td></b-td>
            <b-td></b-td>
            <b-td class="table-action-column">
              <b-button
                :id="`poste-livraison-show-${poste.id}`"
                :class="{
                  'info-btn--saisie': setOnlyReadStyle
                }"
                class="me-2 "
                icon
                outline
                size="sm"
                variant="success"
                v-on:click="prepareShow(poste, 'modal-show-poste-livraison')"
              >
                <i class="fa fa-info"></i>
                <b-tooltip :target="`#poste-livraison-show-${poste.id}`">
                  Afficher la fiche du poste de livraison {{ poste.id }}
                </b-tooltip>
              </b-button>

              <b-button
                v-if="showEditBtn"
                :id="`poste-livraison-edit-${poste.id}`"
                :disabled="isLock"
                class="me-2"
                icon
                outline
                size="sm"
                variant="success"
                v-on:click="prepareEdit(poste)"
              >
                <i class="fa fa-edit"></i>
                <b-tooltip :target="`#poste-livraison-edit-${poste.id}`">
                  Éditer les informations du poste de livraison {{ poste.id }}
                </b-tooltip>
              </b-button>

              <b-button
                v-if="showDeleteBtn"
                :id="`poste-livraison-delete-${poste.id}`"
                :disabled="isLock"
                icon
                outline
                size="sm"
                variant="danger"
                v-on:click="prepareShow(poste, 'modal-delete-poste-livraison')"
              >
                <i class="fa fa-trash"></i>
                <b-tooltip :target="`#poste-livraison-delete-${poste.id}`">
                  Supprimer le poste de livraison {{ poste.id }}
                </b-tooltip>
              </b-button>
            </b-td>
          </b-tr>
        </b-tbody>
        <b-tfoot v-if="showTableAddBtn">
          <b-tr>
            <b-td></b-td>
            <b-td></b-td>
            <b-td></b-td>
            <b-td>
              <b-button-group>
                <span id="poste-livraison-add-btn-2">
                  <b-tooltip target="#poste-livraison-add-btn-2">
                    {{
                      disableAddPosteLivraisonBtn ? "Pour ajouter un nouveau poste de livraison, veuillez déclarer un nombre supérieur dans la fiche du parc" : ''
                    }}
                  </b-tooltip>
                  <b-button
                    id="poste-livraison-add-2"
                    :disabled="disableAddPosteLivraisonBtn || isLock"
                    class="me-2"
                    icon
                    outline
                    variant="success"
                    v-on:click="prepareAdd()"
                  >
                    Ajouter
                    <b-tooltip target="#poste-livraison-add-2">
                      {{ disableAddPosteLivraisonBtn ? "" : "Ajouter un nouveau poste de livraison" }}
                    </b-tooltip>
                  </b-button>
                </span>
              </b-button-group>
            </b-td>
          </b-tr>
        </b-tfoot>
      </b-table-simple>

      <!-- Alertes Exploitant -->

      <div
        v-if="!validNumberPosteLivraison || !isPostesLivraisonDeclared"
        class="alert alert-warning"
        role="alert"
      >
        <span v-if="isPostesLivraisonDeclared">
          <span v-if="isExploitant">Vous avez</span>
          <span v-else>L'exploitant a</span>

          <span> déclaré que le parc était composé de </span>
          <span class="fw-bold">{{ parc.nombrePosteLivraison }} </span>
          <span> poste(s) de livraison. A ce stade, </span>

          <span v-if="isExploitant">vous avez</span>
          <span v-else>il a déjà </span>

          <span> saisi </span>
          <span class="fw-bold">{{ postesLivraison.length }}</span>
          <span> poste(s) de livraison.</span>
        </span>
        <span v-else>
          Aucun poste de livraison n'est déclaré dans la fiche du parc.
        </span>
      </div>

      <div
        v-if="validNumberPosteLivraison && isPostesLivraison"
        class="alert alert-success"
        role="alert"
      >
        Le nombre de postes de livraison déclaré dans la fiche du parc
        correspond au nombre saisi.
      </div>

      <!-- Bouton ajouter si tableau vide -->
      <div v-if="showFirstAddBtn" class="d-flex justify-content-start mb-2">
        <b-button-group>
          <span id="poste-livraison-add-btn">
            <b-tooltip target="#poste-livraison-add-btn">
              {{ !isInventaireCommunes ? "Veuillez spécifier au moins une commune d'implantation" : '' }}
            </b-tooltip>
            <b-button
              id="poste-livraison-add"
              :disabled="!isInventaireCommunes || isLock"
              icon
              outline
              variant="success"
              v-on:click="prepareAdd()"
            >
              Ajouter
              <b-tooltip target="#poste-livraison-add">
                Ajouter un nouveau poste de livraison
              </b-tooltip>
            </b-button>
          </span>
        </b-button-group>
      </div>
      <b-row>
        <b-col v-if="showHelpField" class="mx-2 mt-1 mb-3 help-field">
          * L'ordre de saisie des postes de livraison doit correspondre au
          numéro des postes de livraison (PL1, PL2, etc.) qui figurent dans les
          dossiers administratifs.
        </b-col>
      </b-row>
    </card>

    <!-- MODALE AFFICHAGE -->
    <poste-livraison-list-modal
      :icon-url="iconUrl"
      :map-center="mapCenter"
      :map-zoom="mapZoom"
      :markers="markers"
      :poste="poste"
    />

    <!-- MODALE SUPPRESSION -->
    <poste-livraison-delete-modal
      :addNotification="addNotification"
      :poste="poste"
    />

    <!-- MODALE AJOUT/MODIFICATION -->
    <poste-livraison-edit-modal
      :addNotification="addNotification"
      :coordinatesAlert="coordinatesAlert"
      :is-loading-coordinates-validation="isLoadingCoordinatesValidation"
      :is-update-from="isUpdateFrom"
      :map-center="mapCenter"
      :map-zoom="mapZoom"
      :markers="markers"
      :poste="poste"
      @remove-marker="removeMarker"
      @on-input-coordinates="onInputCoordinates"
      @update-coordinates="updateCoordinates"
      @on-click-map="onClickMap"
      @reload-parc="$emit('reload-parc')"
      @check-coordinates="checkCoordinates"
      @set-loading-validation="setLoadingValidation"
    />

  </div>
</template>
<script setup>
import {mapService} from "@/service/map.service.js";
import proj4 from 'proj4';

import {
  BButton,
  BButtonGroup,
  BCol,
  BRow,
  BTableSimple,
  BTbody,
  BTd,
  BTfoot,
  BTh,
  BThead,
  BTooltip,
  BTr,
  useModal
} from "bootstrap-vue-next";
import PosteLivraisonDeleteModal from "@/components/Modals/PosteLivraisonDeleteModal.vue";
import {computed, onMounted, ref} from "vue";
import {useReactiveStoreGetters} from "@/composables/useStore";
import store from "@/store";
import PosteLivraisonListModal from "@/components/Modals/PosteLivraisonListModal.vue";
import PosteLivraisonEditModal from "@/components/Modals/PosteLivraisonEditModal.vue";
import {commonService} from "@/service/common.service";

const {show: showListModal} = useModal("modal-show-poste-livraison");
const {show: showDeleteModal} = useModal("modal-delete-poste-livraison");
const {show: showEditModal} = useModal("modal-edit-poste-livraison");

// Emits
const emit = defineEmits(['reload-parc'])

// Data
const poste = ref(null);
const emptyfield = "Non renseigné(e)";
const markers = ref([]);
const communeGeoms = ref([]);
const isUpdateFrom = ref(true);
const iconUrl = require("../assets/img/marker-icon-2x-green.png")
const isLoadingCoordinatesValidation = ref(null)
const coordinatesAlert = ref({});

// Lifecycle hook
onMounted(() => {
  mapService.setDefaultIcons();
})

// MapGetters
const {
  parc,
  postesLivraison,
  epsg,
  isExploitant,
  isDreal,
  isGestionnaire,
  isAdministrateur,
  isAdministrateurPortail,
  isAdministrateurRegionParc,
  isBrouillon,
  isPostesLivraison,
  isPostesLivraisonDeclared,
  isInventaireCommunes,
  isLock,
  projections,
  defaultMapZoom,
  baseLayer,
  selectedMapElement,
  postesLivraisonNextId,
} = useReactiveStoreGetters([
  "parc",
  "postesLivraison",
  "epsg",
  "isExploitant",
  "isDreal",
  "isGestionnaire",
  "isAdministrateur",
  "isAdministrateurPortail",
  "isAdministrateurRegionParc",
  "isBrouillon",
  "isPostesLivraison",
  "isPostesLivraisonDeclared",
  "isInventaireCommunes",
  "isLock",
  "projections",
  "defaultMapZoom",
  "baseLayer",
  "selectedMapElement",
  "postesLivraisonNextId",
]);

// Computed
const isEnabledDrealElement = computed(() => {
  return (
    (isAdministrateur.value && isAdministrateurRegionParc.value) ||
    isAdministrateurPortail.value ||
    isGestionnaire.value
  );
});

const setOnlyReadStyle = computed(() => {
  return !isBrouillon.value && !isEnabledDrealElement.value;
});

const showEditBtn = computed(() => {
  return isBrouillon.value || isEnabledDrealElement.value;
});

const showDeleteBtn = computed(() => {
  return isBrouillon.value || isEnabledDrealElement.value;
});

const showTableAddBtn = computed(() => {
  return isBrouillon.value || isEnabledDrealElement.value;
});

const showFirstAddBtn = computed(() => {
  return (
    (isBrouillon.value || isEnabledDrealElement.value) &&
    !isPostesLivraison.value &&
    isPostesLivraisonDeclared.value
  );
});

const showHelpField = computed(() => {
  return (
    (isBrouillon.value || isEnabledDrealElement.value) &&
    isEnoughPosteLivraisonDeclared.value &&
    parc.value.nombrePosteLivraison > 1
  );
});

const isCoordinates = computed(() => {
  if (!poste.value) return false
  return poste.value.hasOwnProperty("yposteLivraison")
    && poste.value.yposteLivraison != null
    && poste.value.yposteLivraison != ""
    && poste.value.hasOwnProperty("xposteLivraison")
    && poste.value.xposteLivraison != null
    && poste.value.xposteLivraison != "";
});

const wgs64FromXY = computed(() => {
  if (isCoordinates.value) {
    return proj4(`EPSG:${epsg.value}`).inverse([parseFloat(poste.value.xposteLivraison), parseFloat(poste.value.yposteLivraison)]);
  }
});

const mapCenter = computed(() => {
  if (markers.value.length > 0) {
    return [markers.value[0][0], markers.value[0][1]];
  } else if (communeGeoms.value[0]) {
    return mapService.getMultipolygonCenter(communeGeoms.value[0]);
  }
  return projections.value[epsg.value].wgs84Center;
});

const mapZoom = computed(() => {
  if (isCoordinates.value || communeGeoms.value[0]) {
    return 13;
  }
  return defaultMapZoom.value;
});

const isEnoughPosteLivraisonDeclared = computed(() => {
  return postesLivraison.value.length < parc.value.nombrePosteLivraison;
});

const validNumberPosteLivraison = computed(() => {
  return postesLivraison.value.length === parc.value.nombrePosteLivraison;
});

const disableAddPosteLivraisonBtn = computed(() => {
  return (
    validNumberPosteLivraison.value === true ||
    isEnoughPosteLivraisonDeclared.value === false
  );
});

// Methods
const prepareShow = async (posteValue, id) => {
  poste.value = posteValue;
  addMarker();
  await mapService.setMapLayout();
  switch (id) {
    case "modal-show-poste-livraison":
      showListModal();
      break;
    case "modal-delete-poste-livraison":
      showDeleteModal();
      break;
    default:
      break;
  }
};

const prepareEdit = async (posteValue) => {
  isUpdateFrom.value = true;
  poste.value = posteValue;

  addMarker();

  await mapService.setMapLayout();
  showEditModal();
};

const prepareAdd = async () => {
  isUpdateFrom.value = false;

  poste.value = {
    id: parc.value.id + "_PL" + postesLivraisonNextId.value,
    parc: {id: parc.value.id},
    xposteLivraison: null,
    yposteLivraison: null,
  };

  await mapService.setMapLayout();
  showEditModal();
};

const addMarker = () => {
  if (isCoordinates.value) {
    markers.value = [];
    markers.value.push([
      wgs64FromXY.value[1],
      wgs64FromXY.value[0]
    ]);
  }
};

const onClickMap = (event, posteParam) => {
  if (markers.value.length === 0) {
    const localXY = proj4(`EPSG:${epsg.value}`).forward([+event.latlng.lng, +event.latlng.lat]);

    const decimals = 2;
    const factor = (Math.pow(10, decimals));

    posteParam.xposteLivraison = Math.round(localXY[0] * factor) / factor;
    posteParam.yposteLivraison = Math.round(localXY[1] * factor) / factor;

    markers.value.push([
      +event.latlng.lat,
      +event.latlng.lng
    ]);
  }
  checkCoordinates(posteParam);
};

const checkCoordinates = (posteParam) => {

  coordinatesAlert.value = {};
  isLoadingCoordinatesValidation.value =
    posteParam.xposteLivraison !== "" ||
    posteParam.yposteLivraison !== ""
      ? true
      : false;

  if (!posteParam.xposteLivraison || !posteParam.yposteLivraison) {
    isLoadingCoordinatesValidation.value = false;
    return;
  }

  const localWgs84 = proj4(`EPSG:${epsg.value}`).inverse([
    parseFloat(posteParam.xposteLivraison),
    parseFloat(posteParam.yposteLivraison)
  ]);

  mapService
    .checkCoordinates(
      parc.value.id,
      localWgs84[0],
      localWgs84[1]
    )
    .then(response => {
      if (response) {
        debugger;
        if (response.status === 200) {
          response.json().then(data => {
            coordinatesAlert.value = {
              state: "success",
              text: `Le poste se situe bien dans la liste des communes référencées dans le parc (${data.nomCommune}).`
            };
            posteParam.inventaireCommune = data;
          });
        } else if (response.status === 204) {
          response.text().then(message => {
            coordinatesAlert.value = {
              state: "danger",
              text: `Le poste ne se situe pas dans la liste des communes référencées dans le parc.`
            };
          });
        } else {
          commonService.handleUnsuccessfulResponse(response);
        }
      } else {
        commonService.handleNoResponse();
      }
      isLoadingCoordinatesValidation.value = false;
    })
    .catch(err => {
      console.log(err);
    });

};

const removeMarker = (index, posteParam) => {
  if (!isUpdateFrom.value) {
    markers.value.splice(index, 1);
    coordinatesAlert.value = {};
    posteParam.yposteLivraison = null;
    posteParam.xposteLivraison = null;
  }
};

const onInputCoordinates = (posteParam) => {
  // Recalculer les markers en fonction du poste de livraison passé
  if (posteParam.xposteLivraison && posteParam.yposteLivraison) {
    const localWgs84 = proj4(`EPSG:${epsg.value}`).inverse([
      parseFloat(posteParam.xposteLivraison),
      parseFloat(posteParam.yposteLivraison)
    ]);

    markers.value = [];
    markers.value.push([
      localWgs84[1],
      localWgs84[0]
    ]);
  }

  checkCoordinates(posteParam);
};

const updateCoordinates = (location, posteParam) => {
  const localXY = proj4(`EPSG:${epsg.value}`).forward([+location.latlng.lng, +location.latlng.lat]);

  const decimals = 2;
  const factor = (Math.pow(10, decimals));

  posteParam.xposteLivraison = Math.round(localXY[0] * factor) / factor;
  posteParam.yposteLivraison = Math.round(localXY[1] * factor) / factor;
};

const addNotification = (response, httpMethod) => {
  if (response) {
    // OK
    if (response.status == "200") {
      response.text().then(message => {
        const notificationTextMessage = message;
        const notificationIcon = "ti-check";
        const notificationType = "success";

        store.dispatch("saveTextNotification", {
          notificationIcon,
          notificationType,
          notificationTextMessage
        });

        emit("reload-parc");
      });
      // BAD REQUEST
    } else if (response.status == "400") {
      // POST/PUT
      if (httpMethod == "POST" || httpMethod == "PUT") {
        response.json().then(message => {
          const notificationJsonMessage = message;
          const notificationTitle =
            "Les modifications n'ont pas été prises en compte";
          const notificationIcon = "ti-alert";
          const notificationType = "danger";

          store.dispatch("saveJsonNotification", {
            notificationTitle,
            notificationIcon,
            notificationType,
            notificationJsonMessage
          });
        });
        // DELETE
      } else {
        const notificationTextMessage = "La suppression a échouée";
        const notificationIcon = "ti-alert";
        const notificationType = "danger";

        store.dispatch("saveTextNotification", {
          notificationIcon,
          notificationType,
          notificationTextMessage
        });

        console.log(response);
      }
      // Other HTTP response
    } else {
      let notificationIcon = "ti-alert pt-1";
      let notificationType = "danger";
      let notificationTextMessage = "Une erreur est survenue";

      // FORBIDDEN
      if (response.status == "403") {
        notificationIcon = "ti-lock pt-1";
        notificationTextMessage =
          "Vous avez tenté d'accéder à une ressource non autorisée";

        // INTERNAL ERROR
      } else if (response.status == "500") {
        notificationTextMessage = "Le serveur a rencontré une erreur";
      }

      store.dispatch("saveTextNotification", {
        notificationIcon,
        notificationType,
        notificationTextMessage
      });

      throw Error(`Request rejected with status ${response.status}`);
    }
  } else {
    const notificationIcon = "ti-alert pt-1";
    const notificationType = "danger";
    const notificationTitle = "La connexion a été interrompue";
    const notificationJsonMessage = ["Veuillez réactualiser la page"];

    store.dispatch("saveJsonNotification", {
      notificationTitle,
      notificationIcon,
      notificationType,
      notificationJsonMessage
    });
  }
};

const onLineHover = (elementId) => {
  store.dispatch("saveSelectedMapElement", elementId);
};

const onLineOut = () => {
  store.dispatch("saveSelectedMapElement", null);
};

const isSelectedLine = (elementId) => {
  return selectedMapElement.value === elementId;
};

const setLoadingValidation = () => {
  isLoadingCoordinatesValidation.value = true;
};

</script>
<style lang="scss">
.poste-livraison-list {
  .info-btn {
    &--saisie {
      margin-left: 10px;
    }
  }

  .empty-field {
    font-style: italic;
  }

  .help-field {
    color: #343a40;
    font-style: italic;
    font-size: 0.8em;
  }

  .selected-line {
    background: #ececec;
  }
}

.poste-livraison-form {
  .form-control {
    border: #ced4da 1px solid;
  }

  &__title {
    font-size: 1.6rem;
    margin-bottom: 0;
    margin-left: 3px;
  }

  &__checkbox > * {
    cursor: pointer;
  }

  .date-list {
    &__deleteBtn {
      border: none;
    }
  }
}

.modal-delete {
  &__text {
    margin-left: 2px;
  }
}

.table-action-column {
  width: 188px;
}
</style>
